import { createRoot } from 'react-dom/client';
import { Bootloader } from './Bootloader';

createRoot(document.getElementById('root')!).render(<Bootloader />);
